import logo from "../assets/logo.svg";
import hero from "../assets/hero.jpg";
import instagram from "../assets/instagram.svg";
import facebook from "../assets/facebook.svg";
import arrowDown from "../assets/arrow-down.svg";
import plus from "../assets/plus.svg";
import minus from "../assets/minus.svg";
import asc from "../assets/asc.svg";
import desc from "../assets/desc.svg";
import success from "../assets/success.svg";
import error from "../assets/error.svg";
import product1 from "../assets/product-1.jpg";
import product2 from "../assets/product-2.jpg";
import product3 from "../assets/product-3.jpg";
import product4 from "../assets/product-4.jpg";
import product5 from "../assets/product-5.jpg";
import product6 from "../assets/product-6.jpg";
import product7 from "../assets/product-7.jpg";
import product8 from "../assets/product-8.jpg";

const images = {
  logo,
  hero,
  facebook,
  instagram,
  arrowDown,
  plus,
  minus,
  asc,
  desc,
  success,
  error,
  product1,
  product2,
  product3,
  product4,
  product5,
  product6,
  product7,
  product8,
};

export default images;
